import { useEffect } from "react";

export default function IndexPage() {
  useEffect(() => {
    location.href = process.env.NEXT_PUBLIC_AUTH_URL as string;
  }, []);

  return null;
}
